import { apiAxiosCMS } from 'services/api';

export async function deleteTrainingReq(id: string) {
	return await apiAxiosCMS
		.delete(`/training/${id}`)
		.then(() => {
			return true;
		})
		.catch((error) => {
			console.error('✌️error --->', error);
			return false;
		});
}
